import { useEffect, useState } from "react";

/**
 * countDownSeconds 부터 카운트다운하는 timer
 */
export default function useTimer({
  countDownSeconds,
  onFinish,
}: {
  countDownSeconds: number;
  onFinish: () => void;
}) {
  const [seconds, setSeconds] = useState(countDownSeconds);
  const [isRunning, setIsRunning] = useState(false);

  useEffect(() => {
    if (!isRunning) return;

    const timer = setInterval(() => {
      setSeconds((prev) => {
        if (prev === 0) {
          clearInterval(timer);
          setIsRunning(false);
          onFinish();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isRunning, onFinish]);

  const stopTimer = () => {
    setIsRunning(false);
    setSeconds(countDownSeconds);
  };

  const startTimer = () => {
    setIsRunning(true);
    setSeconds(countDownSeconds);
  };

  const minutes = String(Math.floor(seconds / 60)).padStart(2, "0");
  const remainingSeconds = String(seconds % 60).padStart(2, "0");

  return {
    minutes,
    seconds: remainingSeconds,
    stopTimer,
    startTimer,
  };
}
